<birdz-card [isLoading]="isLoading" [isEmpty]="!hasPerimeter || !isAvailableForSelectedTecho">
  <div card-title>
    {{ 'EQUIPMENTS_AND_DEVICES' | transloco }}
    <button
      class="help-button bdz-mat-icon-button-info-variant"
      [matTooltip]="'HELP' | transloco"
      matIconButton
      (click)="help()"
    >
      <mat-icon>help</mat-icon>
    </button>
  </div>
  <div card-corner class="corner-export-icon">
    @if (hasPerimeter && isAvailableForSelectedTecho && !isLoading) {
      <button
        matIconButton
        class="bdz-mat-icon-button-primary"
        (click)="export()"
        [matTooltip]="'EXPORT_DATA' | transloco"
      >
        <mat-icon>download_2</mat-icon>
      </button>
    }
  </div>
  <div card-subtitle>
    @if (hasPerimeter && isAvailableForSelectedTecho && equippingLastModified) {
      {{ 'DATE_AT' | transloco }}
      {{ equippingLastModified | formatDatetimeTimezone }}
    }
  </div>
  <div card-empty>
    {{ (!isAvailableForSelectedTecho ? 'NOT_AVAILABLE_FOR_SELECTED_TECHNO' : 'PLEASE_SELECT_A_CONTRACT') | transloco }}
  </div>
  <div card-body class="body">
    @if (equippingStats) {
      @if (equippingStats.pds_total === null) {
        <div class="no-data">{{ 'NO_DATA_AVAILABLE' | transloco }}</div>
      } @else {
        <!-- total -->
        <div class="total">
          <span>
            {{ 'METERS_TOTAL' | transloco }}{{ 'COLON' | transloco }} {{ equippingStats.pds_total | formatNumber }}
          </span>
          <div class="toggle">
            @if (!isRemoteReadView) {
              <mat-slide-toggle [(ngModel)]="isDetailedView" (change)="toggleView()">
                {{ 'DETAILED_VIEW' | transloco }}
              </mat-slide-toggle>
            }
            @if (isBirdzAdmin$ | async) {
              <div class="bdz-birdz-admin">
                <mat-slide-toggle [(ngModel)]="isRemoteReadView" (change)="toggleView()">
                  {{ 'REMOTE_READ_VIEW' | transloco }}
                </mat-slide-toggle>
              </div>
            }
          </div>
        </div>

        <!-- chart -->
        @if (chartOptions) {
          <div class="chart-layout">
            <highcharts-chart
              class="chart"
              (chartInstance)="setChartInstance($event)"
              [options]="chartOptions"
            ></highcharts-chart>
            <div class="legend">
              <app-legend-item
                id="equipped_meters"
                [chart]="chart"
                [update]="updateFlag"
                [color]="categoryColors['EQUIPPED']"
                title="{{ 'EQUIPPED_METERS' | transloco }}"
                [subtitle]="subtitle"
                [children]="getEquippedMetersLegendChildren()"
                [forceDisplay]="true"
              />
              <app-legend-item
                id="equipped_meters_fix_network"
                [chart]="chart"
                [update]="updateFlag"
                [level]="1"
                title="{{ 'EQUIPPED_METERS_FIX_NETWORK' | transloco }}"
                [subtitle]="subtitle"
              />
              <app-legend-item
                id="equipped_meters_walk_by"
                [chart]="chart"
                [update]="updateFlag"
                [level]="1"
                title="{{ 'EQUIPPED_METERS_WALK_BY' | transloco }}"
                [subtitle]="subtitle"
              />
              @for (legendItem of detailedEquippedMetersLegendItems; track legendItem) {
                <app-legend-item
                  [id]="legendItem.id"
                  [chart]="chart"
                  [update]="updateFlag"
                  [level]="1"
                  [title]="legendItem.title"
                  [subtitle]="subtitle"
                />
              }
              @if ((this.equippingStats.pds_not_birdz ?? 0) > 0) {
                <app-legend-item
                  id="non_birdz_device_meters"
                  [chart]="chart"
                  [update]="updateFlag"
                  [level]="1"
                  title="{{ 'NON_BIRDZ_DEVICE_METERS' | transloco }}"
                  [subtitle]="subtitle"
                />
              }
              <app-legend-item
                id="non_equipped_meters"
                [chart]="chart"
                [update]="updateFlag"
                [color]="categoryColors['NON_EQUIPPED']"
                title="{{ 'NON_EQUIPPED_METERS' | transloco }}"
                [subtitle]="subtitle"
              />
            </div>
          </div>
        }
        <!-- main -->
        @if (equippingStats) {
          <div class="figure">
            {{
              (equippingStats.pds_total !== 0
                ? ((equippingStats.pds_equipped ?? 0) / equippingStats.pds_total) * 100
                : 0
              ) | formatNumber: '0.0-1'
            }}% {{ 'OF_EQUIPPED_METERS' | transloco }}
          </div>
        }
      }
      <ng-template #main>
        <!-- total -->
        <div class="total">
          {{ 'METERS_TOTAL' | transloco }}{{ 'COLON' | transloco }} {{ equippingStats.pds_total ?? 0 | formatNumber }}
        </div>
        <!-- chart -->
        @if (chartOptions) {
          <highcharts-chart class="chart" [options]="chartOptions"></highcharts-chart>
        }
        <!-- main -->
        @if (equippingStats) {
          <div class="figure">
            {{
              ((equippingStats.pds_total ?? 0) !== 0
                ? ((equippingStats.pds_equipped ?? 0) / (equippingStats.pds_total ?? 0)) * 100
                : 0
              ) | formatNumber: '0.0-1'
            }}% {{ 'OF_EQUIPPED_METERS' | transloco }}
          </div>
        }
      </ng-template>
    }
  </div>
</birdz-card>
